import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

// Only supports default which is color: dark and size: medium
//      and color: grey size: small, medium
export const TrashIcon = (props) => {
    
    let style = '';

    // Handle sizes  ====================================
    if (props.size === 'small') {
        style = style + ' trash-icon-small';
    }
    if (props.size === 'medium') {
        style = style + ' trash-icon-medium';
    }

    // Handle colors ====================================
    if (props.color === 'grey') {
        style = style + ' trash-icon-grey';
    }

    // Render font
    return (
        <FontAwesomeIcon className={style.trim()} icon={faTrashAlt} />
    )
}
export default TrashIcon;




// WEBPACK FOOTER //
// ./src/components/icons/TrashIcon.js